module.exports = __webpack_public_path__ + "img/8_of_Diamonds.svg.58cebfcc.png";